import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import Store from './store';

// Визуализируем элемент React в корневом узле DOM.
// Сделаем репозиторий Redux доступным для любого
// вложенного компонента, которыму необходим доступ к репозиторию.
ReactDOM.render(
    <Provider store={Store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
